import React, { Component } from 'react';
import AsideContentContainer from '../../components/AsideContentContainer/AsideContentContainer';
import BillingAddressForm from './BillingAddressForm/BillingAddressForm';
import CTABannerContainer from '../../components/CTABannerContainer/CTABannerContainer';
import NotificationBanner, { NOTIFICATION_TYPE } from '../../../shared-components/NotificationBanner/NotificationBanner';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {submit, getFormValues, change, touch} from 'redux-form';
import ToolTip from '../../../shared-components/ToolTip/ToolTip';
import UserInfoCard from '../../components/UserInfoCard/UserInfoCard';
import { FormattedMessage, FormattedHTMLMessage, injectIntl, intlShape } from 'react-intl';
import { push } from 'connected-react-router';
import { showBillingAddressForm, submitBillingInfo } from './BillingAddressPageActions';
import { PAGE_NAME } from '../../config/pageNames';
import { FLOW_TYPE, FORM_ID, CREDIT_TYPE } from '../../../framework/App/AppConstants';
import { saveDataInSession } from '../../../framework/store/ServerData/ServerDataActions';
import { trackTransition, recordImpression } from '../../../framework/store/FPTI/FPTIActions';
import { triggerEnsightenEvent } from '../../../framework/store/Ensighten/EnsightenActions';
import { ENSIGHTEN_APP_START, ENSIGHTEN_APP_SOFT_DECLINED } from '../../../framework/store/Ensighten/EnsightenConstants';
import _ from 'lodash';
import StickyContainer from '../../../shared-components/StickyContainer/StickyContainer';
import StickyBody from '../../../shared-components/StickyBody/StickyBody';
import StickyFooter from '../../../shared-components/StickyFooter/StickyFooter';
import CancelUrl, { COMPONENT_STYLE } from '../../components/CancelUrl/CancelUrl';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import GriffinPhone from 'griffin-paypal/lib/client/phone';
import { requiredBillingAddressFormFields } from './BillingAddressForm/BillingAddressFormUtils';
import { getInitialFormValues } from '../../config/form';
import { isSoftDecline, isElementInViewport, isDeliveryAddressValidationError } from '../../utils/USUtils';
import { CONTEXT_TYPE } from '../../../framework/App/SkeletonPage/SkeletonPageConstants';
import Button, {BUTTON_STYLE} from '../../../shared-components/Button/Button';
import './BillingAddressPage.less';
import { spinnerOpen } from '../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import { SPINNER_DEFAULT_MESSAGE_TYPE } from '../../../framework/components/FullPageSpinner/FullPageSpinnerConstants';


const LOCALE_PREFIX = 'US/pages/BillingAddressPage/BillingAddressPage';

export class BillingAddressPage extends Component {
    static propTypes = {
        creditType: PropTypes.string.isRequired,
        user: PropTypes.object,
        address: PropTypes.object,
        formValues: PropTypes.object.isRequired,
        intl: intlShape.isRequired,
        isFormShowing: PropTypes.bool,
        onClickContinue: PropTypes.func.isRequired,
        onClickX: PropTypes.func.isRequired,
        submitCallback: PropTypes.func.isRequired,
        onUpdate: PropTypes.func.isRequired,
        merchantName: PropTypes.string,
        showSoftDeclineMessage: PropTypes.bool.isRequired,
        showDeliveryAddressValidationError: PropTypes.bool.isRequired,
        isMiniBrowser: PropTypes.bool,
        flow: PropTypes.oneOf(Object.values(FLOW_TYPE)),
        onComponentDidMount: PropTypes.func.isRequired,
        recordImpression: PropTypes.func,
        isAddressNormalizationOn: PropTypes.bool,
        showProfilePicture: PropTypes.bool
    };
    static defaultProps = {
        onComponentDidMount: () => {}
    };

    componentDidMount() {
        this.props.onComponentDidMount(this.props);
        this.triggerElementVisibility();
    }

    triggerElementVisibility() {
        const continueBtnVisible = isElementInViewport('billingInfoContinueBtn');
        const cancelBtnVisible = isElementInViewport('billingInfoCancelBtn');
        this.props.recordImpression('billinginfopage', `continueBtn:${continueBtnVisible}`);
        this.props.recordImpression('billinginfopage', `cancelBtn:${cancelBtnVisible}`);
    }

    handleSubmit = () => {
        const { submitCallback, formValues, isAddressNormalizationOn } = this.props;
        return submitCallback(formValues, PAGE_NAME.PERSONAL_INFO_PAGE, isAddressNormalizationOn);
    };

    handleClickContinue = () => {
        const { onClickContinue, isFormShowing } = this.props;
        return onClickContinue(isFormShowing, PAGE_NAME.PERSONAL_INFO_PAGE);
    };

    handleClickX = event => {
        this.props.onClickX(event);
    };

    getHeader() {
        const flow = this.props.flow;

        // Passing singleColumnLayout as false as the header  width will change based on aside content.
        const defaultHeader = (<Header onCancel={this.handleClickX} singleColumnLayout={false} />);

        if (flow !== FLOW_TYPE.TESLA && flow !== FLOW_TYPE.VENICE) {
            return defaultHeader;
        }

        return '';
    }

    getFormHeader() {
        const { intl, isFormShowing } = this.props;

        const defaultFormHeaderContent = (
            isFormShowing ? (
                <FormattedMessage
                    id={`${LOCALE_PREFIX}.header-enter`}
                />
            ) : (
                <FormattedMessage
                    id={`${LOCALE_PREFIX}.header-confirm`}
                />
            )
        );

        const toolTip = (
            <ToolTip
                id="billingAddressToolTip"
                text={intl.formatMessage({
                    id: `${LOCALE_PREFIX}.tooltip`
                })}
            />
        );

        return (
            <div className="form-header">
                <h1 id="billing-address-header"
                    className="alpha has-tooltip-icon"
                >
                    {defaultFormHeaderContent}
                    {toolTip}
                </h1>
            </div>
        );
    }

    render() {
        const {
            intl, creditType, onUpdate, user, address, isFormShowing,
            showSoftDeclineMessage, flow, showProfilePicture
        } = this.props;
        let billingAddress;

        const firstName = _.get(user, 'firstName');
        const lastName = _.get(user, 'lastName');

        const header = this.getHeader();
        const formHeader = this.getFormHeader();

        const softDeclineBanner = (
            <NotificationBanner
                id="softDeclineMsg"
                message={intl.formatMessage({ id: `${LOCALE_PREFIX}.soft-decline-message` })}
                type={NOTIFICATION_TYPE.WARNING}
            />
        );

        let bannerToShow = <CTABannerContainer />;

        capeLog && capeLog('showSoftDeclineMessage:' + showSoftDeclineMessage);
        if (showSoftDeclineMessage) {
            bannerToShow = (
                <NotificationBanner
                    id="softDeclineMsg"
                    message={intl.formatMessage({ id: `${LOCALE_PREFIX}.soft-decline-message` })}
                    type={NOTIFICATION_TYPE.WARNING}
                />
            );
        }

        if (isFormShowing) {
            billingAddress = (
                <BillingAddressForm
                    firstName={firstName}
                    lastName={lastName}
                    onSubmit={this.handleSubmit}
                />
            );
        } else {
            billingAddress = (
                <UserInfoCard
                    user={user}
                    address={address}
                    onUpdate={onUpdate}
                    flow={flow}
                    showProfilePicture={showProfilePicture}
                />
            );
        }

        return (
            <div className="outerWrapper us-wrapper">
                <div id="wrapper">
                    <div id="main">
                        <div id="BillingAddressPage">
                            {header}
                            <div id="content">
                                <div id="content-child" className="row-fluid table-layout">
                                    <div
                                        id="content-left"
                                        className={`${(flow === FLOW_TYPE.TESLA) ? 'span13' : 'span12'} table-cell`}
                                    >
                                        <StickyContainer>
                                            <StickyBody>
                                                {bannerToShow}
                                                <div className="body-content">
                                                    {formHeader}
                                                    {billingAddress}
                                                </div>
                                            </StickyBody>
                                            <StickyFooter fixToBottom={false} fadedBackground={true}>
                                                <div className="body-content">
                                                    <div id="action-buttons" className="buttons">
                                                        <Button
                                                            btnStyle={BUTTON_STYLE.PP_PRIMARY}
                                                            id="billingInfoContinueBtn"
                                                            onClick={this.handleClickContinue}
                                                            data-automation-id="continue"
                                                        >
                                                            <FormattedMessage id={`${LOCALE_PREFIX}.continue-application`} />
                                                        </Button>
                                                        <CancelUrl
                                                            componentType={COMPONENT_STYLE.LINK_BUTTON}
                                                            id="billingInfoCancelBtn"
                                                            fptiEvent={{
                                                                stateName: 'apply_pp_credit_billinginfopage',
                                                                transitionName: 'cancel_apply_pp_credit_billinginfopage'
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </StickyFooter>
                                        </StickyContainer>
                                    </div>
                                    <aside
                                        id="content-right"
                                        className={`${(flow === FLOW_TYPE.TESLA) ? 'span11' : 'span12'} table-cell hide-for-mobile`}
                                    >
                                        <AsideContentContainer />
                                    </aside>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer showCancelUrl={flow !== FLOW_TYPE.TESLA} />
            </div>
        );
    }
}

export const mapStateToProps = state => {
    const initialFormValues = getInitialFormValues(state);
    const requiredFields = requiredBillingAddressFormFields();
    const containsAllRequiredValues = requiredFields.every(field => !_.isEmpty(initialFormValues[field]));
    const showSoftDeclineMessage = isSoftDecline(state);
    const showDeliveryAddressValidationError = isDeliveryAddressValidationError(state);
    const isFormShowing = _.get(state, 'billingAddressPage.showBillingAddressForm') || !containsAllRequiredValues || showSoftDeclineMessage || showDeliveryAddressValidationError;
    const griffinPhoneHandler = GriffinPhone.createHandler(_.get(state, 'serverData.localityMetadata'));
    const telephone = _.get(state, 'serverData.user.telephone');
    const isAddressNormalizationOn = _.includes(['treatment_1', 'treatment_2'], _.get(state, 'serverData.elmo.ANSAddressNormalization'));
    const showProfilePicture = _.includes(['treatment_1'], _.get(state, 'serverData.elmo.BillingInfoProfile'));
    const isMiniBrowser = _.get(state, 'serverData.contextType', '') === CONTEXT_TYPE.MB_CONTEXT;
    return {
        creditType: _.get(state, 'serverData.financingDetails.credit_type', CREDIT_TYPE.CORE),
        user: _.get(state, 'serverData.user'),
        address: _.get(state, 'serverData.billingAddress'),
        isFormShowing,
        formValues: getFormValues(FORM_ID)(state) || {},
        merchantName: _.get(state, 'serverData.merchantName'),
        showSoftDeclineMessage,
        showDeliveryAddressValidationError,
        isMiniBrowser,
        flow: _.get(state, 'serverData.flow'),
        isAddressNormalizationOn,
        showProfilePicture
    };
};

export const mapDispatchToProps = dispatch => ({
    onComponentDidMount(props) {
        capeLog && capeLog('Loading billing info page');
        const { showSoftDeclineMessage, showDeliveryAddressValidationError } = props;
        capeLog && capeLog('showSoftDeclineMessage:' + showSoftDeclineMessage + ', showDeliveryAddressValidationError:' + showDeliveryAddressValidationError);
        //If there is ANS Delivery service validation error (ANS treatment 2) then clear out the address fields and highlight error.
        //Model data cannot be cleared as ANS call is done before NAPE check (ALP1) and NAPE check needs all user info.
        // showDeliveryAddressValidationError is set on server side when ANS response has delivery service element (non-military).
        if (showDeliveryAddressValidationError) {
            for (const addressField of ['street1', 'street2', 'city', 'state', 'postalCode']) {
                dispatch(change(FORM_ID, addressField, ''));
                dispatch(touch(FORM_ID, addressField));
            }
        }
        dispatch(trackTransition('apply_pp_credit_billinginfopage', 'prepare_apply_pp_credit_billinginfopage'));
        if (showSoftDeclineMessage) {
            dispatch(triggerEnsightenEvent(ENSIGHTEN_APP_SOFT_DECLINED));
        } else {
            dispatch(triggerEnsightenEvent(ENSIGHTEN_APP_START));
        }
    },
    onClickContinue(isFormShowing, nextPage) {
        if (isFormShowing) {
            dispatch(submit(FORM_ID));
        } else {
            dispatch(trackTransition('apply_pp_credit_billinginfopage', 'process_apply_pp_credit_billinginfopage'));
            dispatch(push(nextPage));
        }
    },
    onClickX() {
        dispatch(trackTransition('apply_pp_credit_billinginfopage', 'cancel_x_apply_pp_credit_billinginfopage'));
    },
    submitCallback(formValues, nextPage, isAddressNormalizationOn) {
        dispatch(trackTransition('apply_pp_credit_billinginfopage', 'process_apply_pp_credit_billinginfopage'));
        //If ANS address normalization is on treatment 1 then submit the billing info page else go to personal info (next) page
        if (isAddressNormalizationOn) {
            dispatch(spinnerOpen(SPINNER_DEFAULT_MESSAGE_TYPE));
            return dispatch(submitBillingInfo(PAGE_NAME.BILLING_PAGE, formValues, nextPage));
        } else {
            dispatch(saveDataInSession(PAGE_NAME.BILLING_PAGE, formValues));
            return dispatch(push(nextPage));
        }
    },
    onUpdate() {
        dispatch(showBillingAddressForm(true));
    },
    recordImpression
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(BillingAddressPage));
